import {guard} from "./helper";
import Login from "../views/account/Login";
import Registration from "../views/account/Registration";
import AccountInfomation from "../views/account/AccountInfomation";
import AccountLookup from "../views/account/AccountLookup";
import ResetPassword from "../views/account/ResetPassword";
import ResetPasswordFinish from "../views/account/ResetPasswordFinish";
import OrderHistory from "../views/account/OrderHistory";

export default [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/registration',
        name: 'Registration',
        component: Registration
    },
    {
        path: '/account-information',
        name: 'AccountInformation',
        beforeEnter: guard,
        component: AccountInfomation
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: '/account-lookup/:type',
        name: 'AccountLookup',
        component: AccountLookup
    },
    {
        path: '/reset-password-finish/:type',
        name: 'ResetPasswordFinish',
        component: ResetPasswordFinish
    },
    {
        path: '/order-history',
        name: 'OrderHistory',
        beforeEnter: guard,
        component: OrderHistory
    }
]
